import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FAIcon as FontAwesomeIcon } from './FAIcon';
import * as React from 'react'
import { Button, IButtonProps, Loading, Modal, PortalContainer, useToast } from 'uxp/components';
import { generateFullUUID, hasProperty, hasValue, loadScriptFileAsync, parseValue, tryParseJSON } from '../../../util';
import { IContextProvider } from '../../../uxp';
import { extractActionSteps, IAction, IActionStep, ILucyAction, IRedirectWidget } from '../action-editor/ActionEditor';
import jp from 'jsonpath'
import ActionRenderComponent from './ActionRenderComponent';
import { IContextData } from '../../../hooks/useContextData';
interface IActionButtonProps {
    designer?: any
    uxpContext: IContextProvider
    title: string,
    action: IAction,
    styles?: React.CSSProperties
    icon?: string,
    iconPosition?: 'left' | 'right'
    iconStyles?: React.CSSProperties,
    contextData?: IContextData;
    customParams?: any;
    onReloadWidget: () => void;
}

const ActionButton: React.FunctionComponent<IActionButtonProps> = (props) => {

    let [action, setAction] = React.useState<IAction>(null)

    return <React.Fragment>

        <Button
            title={props.title}
            onClick={() => setAction(props.action)}
            styles={props.styles}
            icon={props.icon}
            iconPosition={props.iconPosition}
            iconStyles={props.iconStyles}
        />

        <ActionRenderComponent
            designer={props.designer}
            uxpContext={props.uxpContext}
            action={action}
            contextData={props.contextData}
            customParams={props.customParams}
            onClose={() => { setAction(null) }}
            onReloadWidget={props.onReloadWidget}
        />

    </React.Fragment>
}

export default ActionButton